/** A compact list of facilities documents, e.g. on an equipment or inspection page. */
import { Download, FileText, Image } from 'lucide-react';
import { DOCUMENT_KIND_LABEL, documentUrl, formatBytes, type DocumentSummary } from '../lib/facilities';
import { formatDate } from '../lib/format';

export function DocumentList({ documents, emptyText = 'No documents yet' }: { documents: DocumentSummary[]; emptyText?: string }) {
  if (documents.length === 0) return <p className="px-5 py-4 text-sm text-slate-500">{emptyText}</p>;

  return (
    <ul className="divide-y divide-slate-100">
      {documents.map((document) => {
        const Icon = document.contentType.startsWith('image/') ? Image : FileText;
        return (
          <li key={document.id} className="flex items-start gap-3 px-5 py-3">
            <Icon className="mt-0.5 size-4 shrink-0 text-slate-400" />
            <div className="min-w-0 flex-1">
              <a
                href={documentUrl(document, true)}
                target="_blank"
                rel="noreferrer"
                className="block truncate text-sm font-medium text-slate-900 hover:text-brand-700"
                title={document.fileName}
              >
                {document.title}
              </a>
              <p className="truncate text-xs text-slate-500">
                {DOCUMENT_KIND_LABEL[document.kind]} · {formatBytes(document.sizeBytes)} · {formatDate(document.createdAt)}
              </p>
            </div>
            <a
              href={documentUrl(document)}
              title="Download"
              aria-label={`Download ${document.title}`}
              className="shrink-0 rounded-md p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-700"
            >
              <Download className="size-4" />
            </a>
          </li>
        );
      })}
    </ul>
  );
}
